const staticMethods = require('./lib/static-methods');
const instanceMethods = require('./lib/instance-methods');

module.exports = Object.assign(staticMethods, { instanceMethods });



//////////////////
// WEBPACK FOOTER
// ./node_modules/p-iteration/index.js
// module id = 714
// module chunks = 0